import { createFileRoute } from "@tanstack/react-router";

import { AdminOverviewPage } from "@/components/admin/AdminOverviewPage";

export const Route = createFileRoute("/administrator/")({
  head: () => ({ meta: [{ title: "Overview · GENRL Admin" }] }),
  component: AdminOverviewPage,
});
